import { request, requestFull } from "../../../api/client";
import type {
  NotificationsResponse,
  NotificationSettings,
  UpdateSettingsPayload,
} from "../types";

// ── Notifications ──

export function getNotifications(params?: {
  unread?: boolean;
  limit?: number;
  offset?: number;
}): Promise<NotificationsResponse> {
  const qs = new URLSearchParams();
  if (params?.unread) qs.set("unread", "true");
  if (params?.limit != null) qs.set("limit", String(params.limit));
  if (params?.offset != null) qs.set("offset", String(params.offset));
  const query = qs.toString();
  return requestFull<NotificationsResponse>(
    `/notify/notifications${query ? `?${query}` : ""}`,
  );
}

export function markAllRead(): Promise<{ data: { updated: number } }> {
  return requestFull<{ data: { updated: number } }>(
    "/notify/notifications/read-all",
    { method: "PUT" },
  );
}

export function markOneRead(id: number): Promise<void> {
  return request<void>(`/notify/notifications/${id}/read`, { method: "PUT" });
}

export function deleteNotification(id: number): Promise<void> {
  return request<void>(`/notify/notifications/${id}`, { method: "DELETE" });
}

// ── Settings ──

export function getSettings(): Promise<NotificationSettings> {
  return request<NotificationSettings>("/notify/settings");
}

export function updateSettings(
  payload: UpdateSettingsPayload,
): Promise<NotificationSettings> {
  return request<NotificationSettings>("/notify/settings", {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}
